import React from 'react'

import FormManager from '../../../gd-form/common/form-manager'
import FormError from '../../../gd-form/common/form-error/form-error'
import GDFormModal from "../../../gd-form/form/form-modal-new/form-modal-new"
import Textarea from '../../../../core/gd-form/form-element/textarea/textarea'
import Project from "../../../model2/project/project"
import {ProjectSystemType} from "../../../model2/project/types"

// @ts-ignore
import ProjectStatusSelector from '../../../../core/gd-ui/select-status/project/project'
// @ts-ignore
import Api from '../../../../core/gd/api/api'

type Props = {
    projectFull: Project
}

export default class UpdateStatusFormStatus extends React.Component<Props> {

    private form: FormManager

    constructor(props:Props) {
        super(props)

        const initFormData = {
            status  : this.props.projectFull.statusId ? this.props.projectFull.statusId : this.props.projectFull.systemStatus,
            comments: this.props.projectFull.statusComments ? this.props.projectFull.statusComments : ''
        }

        const formStructure = {
            fields  : {
                status  : {
                    type        : 'select',
                    isRequired  : true
                },
                comments: {
                    type        : 'input',
                    isRequired  : false
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = async (result: any) => {
        const isSystemStatus = [
            ProjectSystemType.FOLDER,
            ProjectSystemType.TAG,
            ProjectSystemType.PAGE,
            ProjectSystemType.CATEGORY,
            ProjectSystemType.SECTION,
            ProjectSystemType.LINK,
            ProjectSystemType.EMBED
        ].includes(this.props.projectFull.systemType)
        const statusId = isSystemStatus ? null : result.status
        const systemStatus = isSystemStatus ? result.status : null

        const response = isSystemStatus ?
            await Api.Project.updateSystemStatus(this.props.projectFull.id,result.status, false).promise()
            :
            await Api.Project.updateStatus(this.props.projectFull.id,result.status, false).promise()

        // trying to close not empty project
        if (response === 'not-empty') {
            gd.modal.hide(()=>{
                gd.modals.project.confirmCloseNotEmpty(this.props.projectFull.id, statusId, systemStatus, async (accepted:boolean)=>{
                    if (accepted) {
                        await Api.Project.updateComment(this.props.projectFull.id,result.comments).promise()

                        gd.growl.success('Project status has been successfully updated.')
                        this.form.reset()
                    }
                })
            })
        } else {
            await Api.Project.updateComment(this.props.projectFull.id,result.comments).promise()
            gd.growl.success('Project status has been successfully updated.')
            gd.modal.hide()
        }
    }

    onStatusChange = (oldStatus: any, newStatus: any) => {
        this.form.setValue("status", newStatus)
    }

    render() {
        return (
            <GDFormModal form={this.form}>
                <div className="tbl">
                    <div className="row">
                        <div className="label">Project status</div>
                        <div className="element">
                            <ProjectStatusSelector className        = "form-project-status"
                                                   projectId        = {this.props.projectFull.id}
                                                   value            = {this.props.projectFull.statusId ? this.props.projectFull.statusId : this.props.projectFull.systemStatus}
                                                   renderValue      = "form"
                                                   placeholder      = "Status"
                                                   makeApiCalls     = {false}
                                                   disabled         = {!gd.ac.check.project.fullAccess(this.props.projectFull.id)}
                                                   attachment       = "top center"
                                                   targetAttachment = "bottom center"
                                                   targetOffset     = "0 0"
                                                   onChange         = {this.onStatusChange}/>

                            <FormError form = {this.form}
                                       name = "status"/>
                        </div>
                    </div>

                    <div className="row">
                        <div className="label">Comments</div>
                        <div className="element">
                            <Textarea size  = "big"
                                      form  = {this.form}
                                      name  = "comments"/>
                            <FormError form = {this.form}
                                       name = "comments"/>
                        </div>
                    </div>
                </div>
            </GDFormModal>
        )
    }
}